/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useEffect, useRef, useContext } from 'react';
import Block from 'wfui-digital-core/es/Block';
import Guttered from 'wfui-digital-core/es/Guttered';
import useDevice from 'wfui-digital-core/es/useDevice';
import PageContext from 'wfui-digital-core/es/PageContext';
import { getClasses } from 'wfui-digital-core/es/lib';
import useWindowScrollPosition from 'wfui-digital-core/es/useWindowScrollPosition';
import { default as TPBLogoIcon } from 'wfui-digital-core/es/ThePrivateBankLogo';
import styles from './ThePrivateBankLogo.less';
var SCROLL_DISTANCE = 150;

var ThePrivateBankLogo = function ThePrivateBankLogo() {
  var logoRef = useRef();
  var device = useDevice();

  var _useContext = useContext(PageContext),
      setContainerRef = _useContext.setContainerRef;

  var _useWindowScrollPosit = useWindowScrollPosition(),
      scrollTop = _useWindowScrollPosit.y;

  useEffect(function () {
    device.isMobile() && setContainerRef('submasthead')(logoRef.current);
  }, [device, setContainerRef]);
  var classNames = getClasses({
    styles: styles,
    device: device,
    classes: ['logo', scrollTop > SCROLL_DISTANCE && 'collapsed']
  });
  var gutterClassnames = getClasses({
    styles: styles,
    classes: ['guttered'],
    device: device
  });
  var containerClassnames = getClasses({
    styles: styles,
    classes: ['logoContainer'],
    device: device
  });
  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    centered: true,
    className: classNames,
    elementRef: logoRef
  }, /*#__PURE__*/React.createElement(Guttered, {
    className: gutterClassnames
  }, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    center: true,
    justifyCenter: device.isMobile(),
    className: containerClassnames
  }, /*#__PURE__*/React.createElement(TPBLogoIcon, null))));
};

export default ThePrivateBankLogo;